import { render, staticRenderFns } from "./Phq9.vue?vue&type=template&id=8261a658&scoped=true&"
import script from "./Phq9.vue?vue&type=script&lang=ts&"
export * from "./Phq9.vue?vue&type=script&lang=ts&"
import style0 from "./Phq9.vue?vue&type=style&index=0&id=8261a658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8261a658",
  null
  
)

export default component.exports